import { ApprovalTrigger } from '@/gql/graphql'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'

export function triggerToText(trigger: ApprovalTrigger) {
  switch (trigger) {
    case ApprovalTrigger.HireCreated:
      return $t('Hire created')
    case ApprovalTrigger.HireChanged:
      return $t('Hire changed')
    case ApprovalTrigger.ClassificationCreated:
      return $t('Classification')
    default:
      return $t('No trigger')
  }
}
